import Header from "./components/Header";
import Hero from "./components/Hero";
import MediaSection from "./components/MediaSection";
import ContactSection from "./components/ContactSection";
import TopicsSection from "./components/TopicsSection";
import CardsSection from "./components/CardsSection";
import FAQSection from "./components/FAQSection";
import UpdatesSection from "./components/UpdatesSection";
import CommentsSection from "./components/CommentsSection";
import AboutSection from "./components/AboutSection";
import AppSection from "./components/AppSection";
import CarouselSection from "./components/CarouselSection";
import RankingSection from "./components/RankingSection";
import IndexSection from "./components/IndexSection";
import FeaturesSection from "./components/FeaturesSection";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />

      <main>
        <Hero />

        <MediaSection />

        <ContactSection />

        <TopicsSection />

        <CardsSection />

        <FAQSection />

        <UpdatesSection />

        <CommentsSection />

        <AboutSection />

        <AppSection />

        <CarouselSection />

        <RankingSection />

        <IndexSection />

        <FeaturesSection />
      </main>

      <Footer />
    </div>
  );
}